const TRANSLATION = {
  common: {
    loading: 'Cargando',
  },
  i18n: {
    English: 'Inglés',
    Spanish: 'Español',
    Russian: 'Ruso',
    'Portuguese (Brazil)': 'Portugués (Brasil)',
    Indonesian: 'Indonesio',
    Czech: 'Checo',
    German: 'Alemán',
    French: 'Francés',
    Italian: 'Italiano',
    Dutch: 'Neerlandés',
    Polish: 'Polaco',
    Vietnamese: 'Vietnamita',
    Turkish: 'Turco',
    Ukrainian: 'Ucraniano',
    Chinese: 'Chino simplificado',
    'Traditional Chinese': 'Chino tradicional',
    Japanese: 'Japonés',
    Korean: 'Coreano',
    Arabic: 'Árabe',
    Persian: 'Persa',
    Thai: 'Tailandés',
    Hindi: 'Hindi',
    Malay: 'Malayo',
    province: {
      Hebei: 'Provincia de Hebei',
      Shanxi: 'Provincia de Shanxi',
      Liaoning: 'Provincia de Liaoning',
      Jilin: 'Provincia de Jilin',
      Heilongjiang: 'Provincia de Heilongjiang',
      Jiangsu: 'Provincia de Jiangsu',
      Zhejiang: 'Provincia de Zhejiang',
      Anhui: 'Provincia de Anhui',
      Fujian: 'Provincia de Fujian',
      Jiangxi: 'Provincia de Jiangxi',
      Shandong: 'Provincia de Shandong',
      Henan: 'Provincia de Henan',
      Hubei: 'Provincia de Hubei',
      Hunan: 'Provincia de Hunan',
      Guangdong: 'Provincia de Guangdong',
      Hainan: 'Provincia de Hainan',
      Sichuan: 'Provincia de Sichuan',
      Guizhou: 'Provincia de Guizhou',
      Yunan: 'Provincia de Yunnan',
      Shaanxi: 'Provincia de Shaanxi',
      Gansu: 'Provincia de Gansu',
      Qinghai: 'Provincia de Qinghai',
      Taiwan: 'Provincia de Taiwán',
      Guangxi: 'Región Autónoma Zhuang de Guangxi',
      Neimenggu: 'Región Autónoma de Mongolia Interior',
      Tibet: 'Región Autónoma del Tíbet',
      Ningxia: 'Región Autónoma Hui de Ningxia',
      Xinjiang: 'Región Autónoma Uigur de Sinkiang',
      HongKong: 'Región Administrativa Especial de Hong Kong',
      Macau: 'Región Administrativa Especial de Macao',
      Beijing: 'Municipio de Pekín',
      Tianjin: 'Municipio de Tianjin',
      Shanghai: 'Municipio de Shanghái',
      Chongqing: 'Municipio de Chongqing',
    },
  },
  pageHeader: {
    product: 'Producto',
    tvcTest: 'Prueba de experiencia TVC',
    tvcEval: 'Evaluación creativa TVC',
    contactUs: 'Contáctanos',
    Pricing: 'Precios',
    Dashboard: 'Comienza ahora',
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    resourceCenter: 'Blog',
    all: 'Todos',
    news: 'Noticias',
    insight: 'Perspectiva',
    case: 'Caso',
  },
  productSwitch: {
    common: {
      comingSoon: 'Próximamente',
    },
    modal: {
      heroTitle: 'Seleccione la prueba que desea ejecutar',
      heroSubtitle:
        'AdEff está listo para ofrecerle información creativa multidimensional siempre que la necesite.',
      remainingTimes: 'Veces restantes: {{count}}',
      supportedAssets: 'Materiales compatibles',
      coreMetrics: 'Métricas clave',
      cognitiveNeuroscienceIndicators: 'Indicadores cognitivo-neuronales',
      consumerAttitudeIndicators: 'Indicadores de actitud del consumidor',
      outputResult: 'Resultado de salida',
      dataReport: 'Informe de datos',
      analysisReport: 'Informe de análisis',
      accessBackend: 'Comienza ahora',
      tabs: {
        tvc: 'Prueba creativa horizontal',
        portrait: 'Prueba creativa vertical',
      },
      cards: {
        tvcQuick: {
          title: 'Horizontal-Prueba rápida',
          descriptionHighlight:
            'Evalúa rápidamente las creatividades para impulsar decisiones basadas en datos',
        },
        tvcBase: {
          title: 'Diagnóstico creativo-horizontal',
          descriptionHighlight:
            'Perfecciona los detalles creativos con sugerencias de modificación accionables',
          value1: 'Creativos TVC/OTV de 10–60 s',
          value2: 'Indicadores cognitivo-neuronales',
        },
        tvcSurvey: {
          title: 'InsightPro-horizontal',
          descriptionHighlight:
            'Análisis creativo multidimensional con guía estratégica de optimización',
          value1: 'Creativos TVC/OTV de 10–60 s',
          value2: 'Indicadores cognitivo-neuronales',
        },
        portraitQuick: {
          title: 'Vertical-Prueba rápida',
          descriptionHighlight:
            'Evalúa rápidamente las creatividades para impulsar decisiones basadas en datos',
        },
        portraitBase: {
          title: 'Diagnóstico creativo-vertical',
          descriptionHighlight:
            'Perfecciona los detalles creativos con sugerencias de modificación accionables',
          value1: 'Creativos verticales de 5–90 s',
          value2: 'Indicadores cognitivo-neuronales',
        },
        portraitSurvey: {
          title: 'InsightPro-vertical',
          descriptionHighlight:
            'Análisis creativo multidimensional con guía estratégica de optimización',
          value1: 'Creativos verticales de 5–90 s',
          value2: 'Indicadores cognitivo-neuronales',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: 'Prueba creativa horizontal',
          assetText: 'Para creatividades TVC/OTV de 10 a 60 s',
        },
        portrait: {
          bannerTitle: 'Prueba creativa vertical',
          assetText: 'Para creatividades verticales de 5 a 90 s',
        },
      },
      items: {
        tvcQuick: {
          description: 'Compara rápidamente creatividades y decide',
        },
        tvcBase: {
          title: 'Diagnóstico creativo',
          description: 'Optimización segundo a segundo para pulir creatividades',
        },
        tvcSurvey: {
          title: 'Análisis profundo',
          description: 'Análisis integral para localizar problemas clave',
        },
        portraitBase: {
          title: 'Diagnóstico creativo',
          description: 'Optimización segundo a segundo para pulir creatividades',
        },
        portraitQuick: {
          description: 'Compara rápidamente creatividades y decide',
        },
        portraitSurvey: {
          title: 'Análisis profundo',
          description: 'Análisis integral para localizar problemas clave',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'Usamos cookies',
    desc: 'Usamos cookies necesarias para garantizar que nuestro sitio web funcione correctamente. Con tu consentimiento, también utilizamos cookies analíticas para mejorar tu experiencia de usuario. Consulta nuestra política de cookies en nuestra política de privacidad.',
    btn1: 'Rechazar todo',
    btn2: 'Aceptar todo',
    cookiePolicy: 'Política de cookies',
  },
  landing: {
    banner: {
      text1: 'Impulsado por IA',
      text2: 'Publicidad',
      text3: 'Pruebas',
      text4: 'Plataforma para pruebas creativas y optimización',
      feature1: 'Decodificación de contenido',
      feature2: 'Predicción de feedback',
      feature3: 'Integración de datos',
      feature4: 'Inferencia de conclusiones',
      btn1: 'Solicitar demostración',
      btn2: 'Crear proyecto',
    },
    info: {
      title:
        'Implementación rápida de la predicción de efectividad de contenidos creativos basada en el modelo de lenguaje multimodal de hipergrafo (HMLLM)* para aumentar el retorno de la inversión publicitaria',
      subTitle:
        '*Este modelo se basa en una amplia gama de pruebas de neurociencia del marketing y construcciones de múltiples agentes',
      detail1: 'Pruebas publicitarias rápidas',
      detail1Desc:
        'AdEff puede obtener la curva de atención del público objetivo, las fluctuaciones emocionales y el compromiso con los contenidos creativos en 15 minutos, proporcionando informes de evaluación detallados y guías de optimización.',
      detail2: 'Selección rápida de las mejores creatividades',
      detail2Desc:
        'AdEff admite la medición simultánea de múltiples creatividades, ayudando a las marcas a tomar decisiones rápidas. Se proporciona un análisis comparativo detallado.',
      detail3: 'Edición con un clic, creación de versiones efectivas y diversas',
      detail3Desc:
        'AdEff admite la edición con un clic y puede generar rápidamente versiones efectivas y diversas, adecuadas para varios escenarios de comunicación.',
    },
    advantages: {
      title: 'Ventajas de AdEff',
      item1Title: 'Respuesta rápida',
      item1Desc: 'Informes en <tmp>15 minutos</tmp> como máximo.',
      item2Title: 'Modelo de IA único',
      item2Desc: 'Único <tmp>modelo de IA</tmp> basado en el feedback del público.',
      item3Title: 'Gráficos visualizados',
      item3Desc:
        '<tmp>Gráficos visualizados</tmp> + interpretación inteligente de IA, informes de pruebas generados con un clic',
      item4Title: 'Amplia base de datos',
      item4Desc: '<tmp>50.000+</tmp> base de datos de creatividades',
      item5Title: 'Equipo de expertos',
      item5Desc: '<tmp>Equipo de expertos</tmp> proporciona apoyo y orientación',
    },
    service: {
      title: 'Opciones de servicio de AdEff',
      desc: 'Elige la opción de servicio que necesitas',
      topTitle: 'Servicio de autoservicio en línea',
      topRow1: 'Desarrollo autónomo del proyecto y realización de pruebas',
      topRow2: 'Gráficos visualizados + informe de interpretación de IA',
      topRow3: 'Análisis objetivo de indicadores neurocientíficos (movimiento ocular + EEG)',
      topRow4: 'Prueba del modelo de IA único',
      bottomTitle: 'Servicio del equipo de expertos',
      bottomRow1: 'Expertos crean proyectos y realizan pruebas',
      bottomRow2:
        'Análisis objetivo de indicadores neurocientíficos (movimiento ocular + EEG), opcional con indicadores subjetivos',
      bottomRow3: 'Gráficos visualizados + informe de interpretación de expertos',
      bottomRow4: 'Prueba del modelo de IA único, opcional con muestras reales',
    },
    footer: {
      title:
        'AdEff se basa en el modelo de lenguaje multimodal de hipergrafo (HMLLM) y construye relaciones complejas entre elementos visuales, señales de EEG y datos de seguimiento ocular para probar rápidamente la creatividad publicitaria',
      email: 'Correo electrónico',
      belongDesc: 'Producto de <tmp>Mininglamp Technology</tmp>',
    },
    startBtn: 'Comienza ahora',
  },
  contact: { title: 'Contáctanos', copy: 'Copiar', message: { success: 'Copia exitosa' } },
  pricing: {
    title: 'Experto en pruebas y optimización creativa impulsado por IA',
    starter: {
      title: 'Inicio',
      desc_1: 'Adecuado para pruebas de uso único, listo para usar al comprar',
      desc_2: 'Adecuado para pruebas a pequeña escala, listo para usar al comprar',
      timesDesc: '<strong>{{count}}</strong> veces prueba',
      timesDesc1: '<strong>{{count}}</strong> veces prueba',
      discount: '50% de descuento',
      originPrice: 'Precio original',
      desc2: 'Modelo de IA único basado en el feedback del público',
      desc3: 'Respuesta rápida, informes en 15 minutos como máximo',
      desc4: 'Gráficos visualizados',
      desc5: 'Interpretación inteligente de IA',
      desc6: 'Base de datos global y estándar',
      cardDesc1: 'Descuento por tiempo limitado, solo {{pricePerTest}}',
      cardDesc2: 'La cuota de pruebas nunca caduca',
    },
    premium: {
      time: 'veces',
    },
    unlimited: {
      title: 'Ilimitado',
      cardDesc1: 'Desde {{pricePerTest}}',
      cardDesc2: 'Cuota válida por un año',
      cardDesc3: 'Benchmark propio personalizado',
      planDesc500: 'Disfruta de 500 pruebas durante todo el año',
      planDesc1000: 'Disfruta de 1.000 pruebas durante todo el año',
    },
    benefits: {
      title: '¿Por qué elegir AdEff?',
      subtitle: 'Con AdEff, puedes obtener los siguientes beneficios:',
      expertSupport: 'Soporte y orientación del equipo de expertos',
      moreNeedsTitle: '¿Tienes otras necesidades de compra?',
      customPlanPrefix: 'Ofrecemos planes flexibles y personalizados — contáctanos en',
      customPlanSuffix: 'para tu solución exclusiva',
    },
    subscribeBtn: 'Suscríbete ahora',
    contactUs: 'Contáctanos',
  },
  login: {
    loginText: 'Iniciar sesión',
    signUpText: '<tmp>Registrarse</tmp> gratis',
    text1: 'Unido al equipo con éxito',
    text1Desc: 'Puedes probar publicidades por ti mismo',
    text2: 'El usuario se ha unido a la empresa',
    text3: 'Invitación al equipo expirada',
    text4: 'El enlace de invitación al equipo ya no es válido.',
    optionText1: '¿Ya tienes una cuenta?',
    optionText2: '¿No tienes una cuenta?',
    alertText1: 'Al registrarme acepto',
    alertText2: 'Estoy de acuerdo con',
    termsOfService: 'Términos de servicio',
    privacy: 'Política de privacidad',
    privacyTips: 'Por favor, marque la casilla de acuerdo antes de registrarse.',
    and: 'y',
    or: 'o',
    next: 'Siguiente',
    googleLogin: 'Iniciar sesión con Google',
    googleSignUp: 'Registrarse con Google',
    loginWithEmail: 'Iniciar sesión con correo electrónico',
    signUpWithEmail: 'Registrarse con correo electrónico',
    password: 'Contraseña',
    emailAddress: 'Dirección de correo electrónico',
    enterEmail: 'Ingresa tu correo electrónico',
    enterPassword: 'Ingresa tu contraseña',
    confirmPassword: 'Confirmar contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    inconsistentPassword: 'Las contraseñas no coinciden',
    verificationCode: 'Código de verificación',
    emptyVerificationCode: 'El código de verificación no puede estar vacío',
    enterVerificationCode: 'Ingresa el código de verificación',
    sendedVerificationCode: 'El código de verificación ha sido enviado a tu correo electrónico',
    emailOrPasswordNotCorrect: 'Correo electrónico o contraseña incorrectos.',
    message: {
      text1: 'Entrada no válida',
      text2: 'El correo electrónico ya está registrado',
      text3: '¡El código de verificación no es válido!',
      text4: 'Esta cuenta no está vinculada a la empresa, ¡por favor vuelve a vincularte!',
      text5: 'Por favor ingresa un formato de correo electrónico válido',
      text6: 'La contraseña debe tener al menos 12 caracteres',
      text7: 'La contraseña debe contener letras mayúsculas, minúsculas y números',
      requestLimit: 'Solicitud excedida, por favor intenta de nuevo más tarde',
    },
  },
  resetPwdPage: {
    submit: 'Enviar',
    emailNotFound: 'Por favor verifica tu correo electrónico',
    emailHasSent: 'Correo electrónico enviado a {{email}}',
    checkYourInbox: 'Verifica tu correo electrónico',
    resetYourPassword: 'Restablecer contraseña',
    resetLinkHasSent:
      'Un enlace para restablecer su contraseña se ha enviado a la dirección de correo electrónico asociada con su cuenta',
    enterYourEmailAddress:
      'Ingresa tu dirección de correo electrónico y te enviaremos un enlace para restablecer tu contraseña',
    didNotGetEmail: '¿No recibiste un correo electrónico?',
    tryAgain: 'Intentar de nuevo',
    goBackToSign: 'Volver a iniciar sesión',
    email: 'Correo electrónico',
    enterYourEmail: 'Ingresa tu dirección de correo electrónico',
    resetPassword: 'Restablecer contraseña',
    resetPwdSuccess: 'Contraseña restablecida con éxito',
    message: {
      resetLinkCodeError: 'El código en el enlace es inválido',
      requestLimit: 'Solicitud excedida, por favor intenta de nuevo más tarde',
    },
  },
  memberRequestPage: {
    title: 'Verificar solicitud de miembro',
    subTitle: 'Solicitud de:',
    deny: 'Rechazar',
    approve: 'Aprobar',
    teamFull: 'Equipo completo',
    yourTeamIsFull:
      'Tu equipo está completo. Puedes contactarnos para obtener más miembros o eliminar a otros miembros.',
    manageMembers: 'Gestionar miembros en AdEff',
    requestApproved: 'Solicitud aprobada',
    approvedDesc:
      'Has aprobado a <tmp>{{name}}</tmp> para unirse a tu equipo, se ha enviado automáticamente un correo electrónico de notificación.',
    requestDeclined: 'Solicitud rechazada',
    declinedDesc:
      'Has rechazado a <tmp>{{name}}</tmp> para unirse a tu equipo, se ha enviado automáticamente un correo electrónico de notificación.',
  },
  infoBindPage: {
    title: 'Pruebas publicitarias impulsadas por IA',
    desc: 'Implementación rápida de la predicción de efectividad de contenidos creativos basada en el modelo de lenguaje multimodal de hipergrafo (HMLLM)* para aumentar el retorno de la inversión publicitaria',
    joinAdEff: 'Únete a AdEff y comienza tu nuevo viaje',
    advantages: {
      title1: 'Más potente',
      desc1: 'Modelo de IA único basado en una amplia base de datos',
      title2: 'Más económico',
      desc2: 'Solo el 10% del precio en comparación con los métodos tradicionales',
      title3: 'Más rápido',
      desc3: 'Informe en 15 minutos como máximo',
      title4: 'Más profesional',
      desc4: 'Disfruta de soporte 24/7 y servicio experto',
    },
    username: 'Nombre de usuario',
    company: 'Empresa',
    placeOfResidence: 'País/Región',
    invitationCode: 'Código de referencia',
    createAccountForFree: 'Crea una cuenta gratis',
    refreshStatus: 'Actualizar estado',
    reapply: 'Reaplicar',
    bySigningUp: 'Al registrarte aceptas',
    termsOfService: 'Términos de servicio',
    and: 'y',
    privacyPolicy: 'Política de privacidad',
    message: {
      success: 'Solicitud de creación de cuenta enviada, ¡por favor espera!',
      success2: 'Cuenta creada con éxito',
      error: 'Error al crear la cuenta, por favor intenta de nuevo más tarde.',
      accountCreatedDirectly: '¡Tu cuenta ha sido creada directamente!',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'La solicitud ha sido aprobada, la página se redirigirá automáticamente.',
      theRequestHasBeenSendAndPleaseBePatient: 'Solicitud enviada, ¡por favor espera!',
      wrongRouting: 'Error de enrutamiento, la página se redirigirá automáticamente.',
      yourRequestHasBeenDeclined:
        'Tu solicitud ha sido rechazada. Puedes volver a solicitar unirte al equipo o crear una nueva cuenta sin código de invitación.',
      waitingForAdministratorReview: 'Esperando revisión del administrador',
      thisFieldIsRequired: 'Este campo es obligatorio',
      pleaseEnterTheResidence: 'Por favor ingresa el país',
      invitationCodeDoesNotExist: 'Código de referencia inválido',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        'Si estás usando esto a través de una referencia de agente, por favor ingresa el código de referencia',
      pleaseEnterTheUsername: 'Por favor ingresa el nombre de usuario',
      pleaseEnterTheCompanyName: 'Por favor ingresa el nombre de la empresa',
      needRegisterAgain: 'Error en la operación, por favor registra nuevamente',
      alreadyBind: 'Ya has vinculado la empresa, por favor no vuelvas a vincularla',
    },
  },
  knowledgeFormPage: {
    name: 'Tu nombre',
    email: 'Tu correo electrónico',
    companyName: 'Nombre de la empresa',
    department: 'Departamento',
    role: 'Cargo',
    country: 'País',
    province: 'Provincia',
    pleaseEnter: 'Por favor ingresa',
    pleaseSelect: 'Por favor selecciona',
    pleaseEnterTheName: 'Por favor ingresa tu nombre',
    pleaseEnterTheEmail: 'Por favor ingresa tu correo electrónico',
    pleaseEnterValidEmail: 'Por favor ingresa un correo electrónico válido',
    pleaseEnterTheCompanyName: 'Por favor ingresa el nombre de la empresa',
    pleaseSelectTheDepartment: 'Por favor selecciona el departamento',
    pleaseSelectTheRole: 'Por favor selecciona el cargo',
    pleaseSelectTheCountry: 'Por favor selecciona el país',
    pleaseSelectTheProvince: 'Por favor selecciona la provincia',
    textIsRequired: 'Este campo es obligatorio',
    submit: 'Enviar',
    download: 'Descargar',
    submitSuccess: 'Solicitud enviada con éxito',
    downloadSuccess: 'Descarga exitosa',
    title1: 'Por favor completa tu información para obtener los recursos',
    title2: 'Por favor selecciona los recursos que deseas descargar',
  },
  dashboard: {
    pdf: {
      downloadReport: 'Descargar informe',
      downloadBtnText: 'Descargar PDF',
      content: 'Contenido',
      theEnd: 'Fin',
      thankYouForWatching: 'Gracias por ver.',
      pdfProcessing: 'Procesando PDF...',
      pdfProcessingDesc:
        'PDF páginas: {{count}}, esperado {{seconds}} segundos, guardar después, por favor espere',
      pdfProcessingDesc2: 'La versión actual del idioma no está traducida, no se puede generar PDF',
    },
    ppt: {
      downloadBtnText: 'Descargar PPT',
      pptProcessingDesc: 'Procesando archivo PPT, por favor espere',
      pptProcessingDesc2: 'La versión actual del idioma no está traducida, no se puede generar PPT',
      pptProcessingDesc3: 'Descargando el archivo PPT, por favor espere...',
      translateCompleted: 'Traducción de PPT completada',
      exportSuccess: 'Archivo PPT exportado con éxito',
      exportFailed: 'Error al exportar archivo PPT',
    },
    layout: {
      projectMenuText: 'Proyectos de prueba publicitaria',
      accountManagementText: 'Gestión de cuentas',
      myAccountText: 'Mi cuenta',
      subscriptionText: 'Suscripción',
      logout: 'Cerrar sesión',
      dataDetails: 'Detalles de datos',
      dataAnalysis: 'Análisis de datos',
      dataOverview: 'Resumen de datos',
      dataComparison: 'Comparación de datos',
    },
    systemMessage: {
      title: 'Mensaje del sistema',
      task: 'Tarea',
      system: 'Sistema',
      noRelevantContent: 'No se encontraron contenidos relevantes',
      noMore: 'No hay más mensajes',
    },
    projectPage: {
      createProject: 'Crear proyecto',
      searchPlaceholder: 'Ingresa el nombre del proyecto/publicidad/marca para buscar',
      sortLabel: 'Ordenar por índice de efectividad del anuncio',
      sortPlaceholder: 'Por favor seleccione el método de ordenación',
      sortOption1: 'En orden ascendente de índice de efectividad',
      sortOption2: 'En orden descendente de índice de efectividad',
      filterSort: 'Filtrar y ordenar',
      filterBenchmarkTitle: 'Filtrar benchmark',
      sortTitle: 'Ordenar',
      tabAllCreative: 'Todas las creatividades ({{count}})',
      tabGeneralCreative: 'Creatividades regulares ({{count}})',
      tabSplashCreative: 'Creatividades splash ({{count}})',
      generalCreativeLabel: 'Creatividad regular',
      splashCreativeLabel: 'Creatividad splash',
      normTypePlaceholder: 'Por favor seleccione el tipo de referencia',
      totalDesc: 'Proyectos de anuncios (total {{total}})',
      noRelevantContent: 'No se encontraron contenidos relevantes',
      loadMore: 'Cargar más',
      projectCard: { delete: 'Eliminar', reanalyze: 'Reanalizar', download: 'Descargar' },
      delete: 'Eliminar',
      cancel: 'Cancelar',
      message: {
        deleteTitle: 'Aviso de eliminación',
        delete:
          'Una vez que se elimine este proyecto, todos los datos asociados no serán accesibles. ¿Realmente deseas continuar?',
        delete1:
          'Este proyecto es un proyecto de prueba gratuito, y al eliminarlo no se devolverá la oportunidad de prueba',
        delete2:
          'Este proyecto aún no ha comenzado el análisis. Después de la eliminación, se reembolsarán tus créditos de prueba',
        deleteSuccess: '¡Eliminación exitosa!',
        analysisCountNotEnough:
          'Número de análisis insuficiente, por favor recarga para continuar.',
        analysisFailed: 'Análisis fallido, por favor intenta de nuevo más tarde.',
        waitingQuestion:
          'Se pueden analizar máximo 3 proyectos simultáneamente. Este proyecto ha entrado en la cola de espera y comenzará el análisis automáticamente más tarde.',
        landscapeQuickCompleted: 'Tu proyecto horizontal de prueba rápida se ha completado.',
        portraitQuickCompleted: 'Tu proyecto vertical de prueba rápida se ha completado.',
        landscapeSurveyCompleted: 'Tu proyecto horizontal de insights profundos se ha completado.',
        portraitSurveyCompleted: 'Tu proyecto vertical de insights profundos se ha completado.',
      },
    },
    projectCreatePage: {
      createProject: 'Crear proyecto',
      basicInformation: 'Información básica',
      projectType: 'Tipo de proyecto',
      projectName: 'Nombre del proyecto',
      categoryType: 'Sector',
      brandName: 'Nombre de la marca',
      advertisingInformation: 'Información publicitaria',
      adName: 'Nombre de la publicidad',
      norm: 'Norma',
      targetMarketNorm: 'Norma del mercado objetivo',
      brandNorm: 'Norma de la marca',
      taGender: 'Género TA',
      targetMarket: 'Mercado objetivo',
      taAge: 'Edad TA',
      next: 'Siguiente',
      previous: 'Anterior',
      confirmOrder: 'Confirmar pedido',
      estTime: 'Tiempo estimado',
      minutes: 'Minutos',
      consumption: 'Consumo de este pedido',
      testPoint: 'Puntos de prueba',
      remaining: 'Restante',
      times: 'veces',
      type: 'Tipo',
      purchase: 'Comprar',
      outputLanguage: 'Idioma de salida',
      durationCategory: 'Tipo de creatividad',
      durationCategoryDesc: 'Las métricas de análisis varían según el tipo de creatividad; selecciona la opción que mejor se ajuste a tu contenido.',
      durationCategoryOptions: {
        tenPlus: 'Creatividad general (10s+)',
        fiveToTen: 'Creatividad de apertura (5-10s)',
      },
      adSelection: {
        adCreativeTest: 'Prueba creativa publicitaria',
        adCreativeTestDesc:
          'Prueba el feedback del público sobre una única creatividad publicitaria y proporciona análisis y recomendaciones',
        adCreativeSelection: 'Selección creativa publicitaria',
        adCreativeSelectionDesc:
          'Compara el feedback de múltiples creatividades publicitarias y elige de manera integral',
        adCreativeEditing: 'Edición creativa publicitaria',
        adCreativeEditingDesc:
          'Selección inteligente de las mejores partes de la creatividad publicitaria, generación automática de creatividades publicitarias',
        launchingSoon: 'Próximamente',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: 'Alimentación y bebidas',
        packagedFood: 'Alimentos empaquetados',
        confectionery: 'Confecciones',
        frozenMeals: 'Comida congelada',
        fastFood: 'Comida rápida',
        beverage: 'Bebidas',
        alcohol: 'Alcohol',
        dairy: 'Lácteos',
        grainAndSeasoning: 'Granos y especias',
        beverageMixes: 'Bebidas y bebidas',
        freshProduce: 'Frutas frescas',
        otherFoodAndBeverage: 'Otros alimentos y bebidas',
        /**----------------------- */
        consumerElectronicsCategory: 'Electrónica de consumo',
        mobilePhone: 'Teléfonos móviles',
        computer: 'Computadoras',
        smartDevice: 'Dispositivos inteligentes',
        phoneAccessories: 'Accesorios de teléfonos',
        computerAccessories: 'Accesorios de computadoras',
        software: 'Software',
        camera: 'Cámaras',
        officeSupplies: 'Artículos de oficina',
        otherConsumerElectronics: 'Otros electrónicos de consumo',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: 'Farmacia y salud',
        otcMedicine: 'Medicamentos OTC',
        prescriptionDrugs: 'Medicamentos recetados',
        healthSupplements: 'Suplementos de salud',
        pharmaceuticalCompanies: 'Empresas farmacéuticas',
        medicalDevices: 'Dispositivos médicos',
        medicalServices: 'Servicios médicos',
        pharmacy: 'Farmacias',
        otherPharmaceuticalsAndHealthCare: 'Otros productos farmacéuticos y de salud',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'Belleza y cuidado personal',
        hairCare: 'Cuidado del cabello',
        womenSkincare: 'Cuidado de la piel de la mujer',
        homeCleaning: 'Limpieza del hogar',
        bodyCare: 'Cuidado corporal',
        feminineCare: 'Cuidado femenino',
        oralCare: 'Cuidado bucal',
        menSkincare: 'Cuidado de la piel de los hombres',
        makeup: 'Maquillaje',
        fragrances: 'Fragancias',
        beautyServices: 'Servicios de belleza',
        otherBeautyAndPersonalCare: 'Otros productos de belleza y cuidado personal',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'Productos maternos e infantiles',
        babyFood: 'Alimentos infantiles',
        babyCareEssentials: 'Cuidado infantil',
        babyToys: 'Juguetes infantiles',
        otherMaternalAndInfantProducts: 'Otros productos maternos e infantiles',
        /**----------------------- */
        networkAndCommunicationCategory: 'Redes y comunicaciones',
        mobileCarriers: 'Operadores de telefonía móvil',
        internetProviders: 'Proveedores de internet',
        telecomEquipment: 'Equipos de telecomunicaciones',
        otherNetworkAndCommunication: 'Otros servicios de redes y comunicaciones',
        /**----------------------- */
        travelAndAccommodationCategory: 'Viajes y alojamientos',
        localTourism: 'Turismo local',
        bookingPlatform: 'Plataformas de reserva',
        hotels: 'Hoteles',
        airlines: 'Aerolíneas',
        airport: 'Aeropuertos',
        otherTravelAndAccommodation: 'Otros viajes y alojamientos',
        /**----------------------- */
        vehiclesCategory: 'Vehículos',
        motorVehicleProductsAndServices: 'Productos y servicios de vehículos',
        carBrands: 'Marcas de automóviles',
        dealerships: 'Concesionarios',
        carFinance: 'Financiación de automóviles',
        evCar: 'Automóviles eléctricos',
        motorcycle: 'Motocicletas',
        onlineUsedCarMarketplace: 'Mercado de automóviles usados en línea',
        carRentalPlatform: 'Plataformas de alquiler de automóviles',
        travelNavigation: 'Navegación de viajes',
        bicycle: 'Bicicletas',
        otherVehicles: 'Otros vehículos',
        /**----------------------- */
        householdAppliancesCategory: 'Electrodomésticos',
        majorAppliances: 'Grandes electrodomésticos',
        healthAndPersonalCareAppliances: 'Electrodomésticos de cuidado personal',
        majorKitchenAndBathAppliances: 'Electrodomésticos de cocina y baño',
        smallKitchenAppliances: 'Electrodomésticos de cocina y baño',
        environmentalAppliances: 'Electrodomésticos de cuidado del medio ambiente',
        cleaningAppliances: 'Electrodomésticos de limpieza',
        otherHouseholdAppliances: 'Otros electrodomésticos',
        /**----------------------- */
        retailAndServiceCategory: 'Categoría de venta minorista y servicios',
        onlineRetailEcommerce: 'Venta minorista en línea/Comercio electrónico',
        departmentStores: 'Grandes almacenes',
        lifeServices: 'Servicios de vida',
        retailServicesAndDelivery: 'Servicios minoristas/Entrega',
        supermarkets: 'Supermercados',
        otherRetailAndService: 'Otros servicios y venta minorista',
        /**----------------------- */
        apparelCategory: 'Ropa y accesorios',
        footwear: 'Calzado',
        clothing: 'Ropa',
        watchesWatchRetail: 'Relojes/Tiendas de relojes',
        jewelry: 'Joyas',
        bags: 'Bolsos',
        eyewearOpticalStores: 'Gafas/Tiendas de gafas',
        otherClothingAndAccessories: 'Otros accesorios de ropa',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'Mejora y decoración del hogar',
        homeFurnishing: 'Decoración del hogar',
        homeImprovement: 'Mejora del hogar',
        otherHomeImprovementAndFurnishings: 'Otros accesorios de ropa',
        /**----------------------- */
        financialAndInsuranceCategory: 'Finanzas y seguros',
        bank: 'Banco',
        fintech: 'Fintech',
        investmentAndFinancialServices: 'Inversión y servicios financieros',
        insurance: 'Seguros',
        otherFinancialAndInsurance: 'Otros productos financieros y de seguros',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'Entretenimiento y ocio',
        socialApp: 'Aplicación social',
        toysAndDolls: 'Juguetes y muñecas',
        concerts: 'Conciertos',
        events: 'Eventos',
        movies: 'Películas',
        themeParks: 'Parques temáticos',
        gambling: 'Juegos de azar',
        onlineGaming: 'Juegos en línea',
        tvChannels: 'Canales de televisión',
        otherEntertainmentAndLeisure: 'Otros entretenimientos y ocio',
        /**----------------------- */
        industrialAndAgriculturalCategory: 'Industria y agricultura',
        industrialSupplies: 'Materiales industriales',
        agriculturalSupplies: 'Materiales agrícolas',
        otherIndustrialAndAgricultural: 'Otros materiales industriales y agrícolas',
        /**----------------------- */
        petLifeCategory: 'Vida de mascotas',
        petFood: 'Alimentos para mascotas',
        petSupplies: 'Accesorios para mascotas',
        otherPetLife: 'Otros accesorios para mascotas',
        /**----------------------- */
        educationAndLearningCategory: 'Educación y aprendizaje',
        onlineLearning: 'Aprendizaje en línea',
        schools: 'Escuelas',
        skillCourses: 'Cursos de habilidades',
        tutoring: 'Tutoría',
        universities: 'Universidades',
        otherEducationAndLearning: 'Otros productos de educación y aprendizaje',
        /**----------------------- */
        communityAndPublicServiceCategory: 'Comunidad y servicios públicos',
        charityCampaigns: 'Campañas de caridad',
        ngoAds: 'Anuncios de ONG',
        otherCommunityAndPublicService: 'Otros servicios de comunidad y públicos',
        /**----------------------- */
        otherCategory: 'Otro',
        governmentAdvertising: 'Anuncios gubernamentales',
        realEstateAdvertising: 'Anuncios inmobiliarios',
        otherAdvertising: 'Otros anuncios',
      },
      genderSelect: {
        male: 'Masculino',
        female: 'Femenino',
        all: 'Todos',
      },
      targetMarketSelect: {
        China: 'China',
        HongKongChina: 'Hong Kong, China',
        MacauChina: 'Macao, China',
        TaiwanChina: 'Taiwán, China',
        Japan: 'Japón',
        Korea: 'Corea',
        Mongolia: 'Mongolia',
        Singapore: 'Singapur',
        Thailand: 'Tailandia',
        Vietnam: 'Vietnam',
        Malaysia: 'Malasia',
        Philippines: 'Filipinas',
        Indonesia: 'Indonesia',
        Cambodia: 'Camboya',
        Laos: 'Laos',
        India: 'India',
        SaudiArabia: 'Arabia Saudita',
        Turkey: 'Turquía',
        Israel: 'Israel',
        UnitedArabEmirates: 'Emiratos Árabes Unidos',
        Qatar: 'Catar',
        Kuwait: 'Kuwait',
        UnitedKingdom: 'Reino Unido',
        France: 'Francia',
        Germany: 'Alemania',
        Netherlands: 'Países Bajos',
        Belgium: 'Bélgica',
        Austria: 'Austria',
        Italy: 'Italia',
        Spain: 'España',
        Portugal: 'Portugal',
        Greece: 'Grecia',
        Sweden: 'Suecia',
        Norway: 'Noruega',
        Finland: 'Finlandia',
        Denmark: 'Dinamarca',
        Estonia: 'Estonia',
        Latvia: 'Letonia',
        Russia: 'Rusia',
        Poland: 'Polonia',
        CzechRepublic: 'República Checa',
        Hungary: 'Hungría',
        Romania: 'Rumanía',
        Bulgaria: 'Bulgaria',
        Slovakia: 'Eslovaquia',
        Slovenia: 'Eslovenia',
        Ukraine: 'Ucrania',
        UnitedStates: 'Estados Unidos',
        Canada: 'Canadá',
        Mexico: 'México',
        Brazil: 'Brasil',
        LatinAmerica: 'América Latina',
        Australia: 'Australia',
        NewZealand: 'Nueva Zelanda',
        Other: 'Otro',
      },
      languageSelect: {
        english: 'Inglés',
        chinese: 'Chino',
        japanese: 'Japonés',
        korean: 'Coreano',
        french: 'Francés',
        traditionalChinese: 'Chino tradicional',
      },
      placeholder: {
        projectName: 'Ingresa el nombre del proyecto',
        category: 'Selecciona una categoría',
        brandName: 'Ingresa el nombre de la marca',
        adName: 'Ingresa el nombre de la publicidad',
        norm: 'Por favor seleccione el valor de referencia',
        taGender: 'Selecciona el género',
        targetMarket: 'Selecciona el mercado objetivo',
        taAge: 'Selecciona la edad',
        lowerLimit: 'Límite inferior',
        upperLimit: 'Límite superior',
        outputLanguage: 'Por favor seleccione el idioma de salida',
      },
      step: {
        step1: 'Ingreso de datos del proyecto',
        step2: 'Confirma la información del pedido',
      },
      message: {
        success: 'Creado con éxito',
        videoDurationOver60s: 'Duración del video superior a {{max}} segundos',
        videoDurationLessThan10s: 'Duración del video inferior a {{min}} segundos',
        videoDurationNeedOver10s: 'La duración del video debe ser superior a 10 s',
        videoDurationNeedWithin5To10s: 'La duración del video debe estar entre 5 s y 10 s',
        videoDurationNotMatchDurationCategory: 'La duración actual del video no cumple con este tipo de proyecto. Vuelve a subir el video e inténtalo de nuevo.',
        videoUploadingCannotSwitchDurationCategory: 'No puedes cambiar el tipo de creatividad mientras se sube el video. Espera a que finalice la subida.',
        videoFormatOrDurationError: 'No se pudo leer el formato o la duración del video. Revisa el archivo de video e inténtalo de nuevo.',
        videoSizeOver200M: 'Tamaño del video superior a 256 MB',
        videoLandscape: 'El video debe estar en formato horizontal',
        videoPortrait: 'El video debe estar en formato vertical',
        clickToUploadTestVideo: 'Haz clic para subir el video de prueba',
        uploadFailed: 'Error al subir, intenta de nuevo',
        uploadDesc1: 'Admite archivos de vídeo en MP4, MOV',
        uploadDescPortrait: 'Admite archivos de video verticales en MP4, MOV',
        uploadDesc2: 'otros formatos, con un límite de tamaño de archivo de hasta 256 MB',
        formNotCompleted: 'Completa toda la información',
        uploadAdVideo: 'Sube el video publicitario',
        inputInvalid: 'Entrada no válida',
        insufficientTestPoints:
          'Puntos de prueba insuficientes, por favor recargue e intente nuevamente.',
        reviewProjectInfo:
          'Revisa cuidadosamente la información de tu proyecto. Una vez confirmado el pedido, no se podrán realizar cambios.',
        waitingDesc:
          'Hasta 3 proyectos pueden analizarse simultáneamente. Los proyectos adicionales entrarán en la cola de espera y serán procesados secuencialmente por el sistema.',
        ageRangeInvalid: 'El rango de edad solo admite 20-55',
        normDesc:
          'Beneficios ilimitados de derechos de autor, valor de referencia personalizado por la empresa',
      },
    },
    projectDetailPage: {
      testResults: 'Resultados de la prueba',
      share: 'Compartir',
      shareFailed: 'Error al compartir',
      shareModal: {
        title: 'Compartir',
        desc: 'Copia el texto de abajo y compártelo en redes sociales.',
        saveImage: 'Guardar imagen',
        copyText: 'Copiar texto',
        copySuccess: 'Copiado',
        copyFailed: 'Error al copiar',
        textTemplate:
          '¡Guau! Mi creatividad con IA superó al {{score}}% de trabajos similares en AdEff. ¡Los datos son lo que realmente cuenta! El test de creatividades con IA de AdEff ahora es gratis. Revisa tu puntuación en {{hostname}}. Obtén 5 pruebas gratuitas, ¡te deseamos excelentes valoraciones!',
      },
      sharePoster: {
        createdByYou: 'Creado por ti',
        scoreTemplate: 'Superó al <score>{{score}}</score> de las creatividades AIGC',
        statsAt: 'Generado el ',
        certification: 'Certificación creativa',
        footerText: '¡Esperamos que sigas creando y trayendo más obras de calidad!',
      },
      basicInformation: 'Información básica',
      waiting: 'En espera',
      ongoing: 'En curso',
      failed: 'Fallido',
      tryAgain: 'Intenta de nuevo',
      videoAnalysisFailed: 'Análisis de video fallido',
      message: { projectNotFound: 'Proyecto no encontrado' },
      primaryAnalysis: 'Rendimiento principal',
      detailAnalysis: 'Análisis detallado',
      heatmapAnalysis: 'Mapa de calor',
      analysisStepDesc:
        'La IA ha completado todas las tareas de análisis, los análisis detallados son los siguientes',
      analysisWaitingDesc:
        'Hasta 3 proyectos pueden analizarse simultáneamente. Los proyectos adicionales entrarán en la cola de espera y serán procesados secuencialmente por el sistema.',
      aiTip: 'El contenido del informe se genera mediante IA y es solo para referencia',
      subAnalysisDescription: {
        adVideoScore: 'Índice de efectividad publicitaria',
        adVideoScoreDesc:
          'El índice de efectividad publicitaria es un indicador integral de la efectividad de la publicidad, capaz de predecir los efectos a corto y largo plazo de las publicidades.',
        norm: 'Norma',
        normDesc:
          'Valor de referencia basado en datos de la industria o históricos para comparar el rendimiento publicitario.',
        attentionIndex: 'Índice de atención',
        attentionIndexDesc:
          'Medida de la atención visual del público, refleja la capacidad de atraer la atención sobre acciones y elementos publicitarios.',
        emotionIndex: 'Índice emocional',
        emotionIndexDesc:
          'Medida del grado en que se activan emociones positivas en el público, refleja las fluctuaciones emocionales inmediatas provocadas por la publicidad.',
        cognitionIndex: 'Índice cognitivo',
        cognitionIndexDesc:
          'Medida del grado en que el público ha procesado los contenidos publicitarios.',
        theGolden3Seconds: 'Los tres segundos dorados',
        theGolden3SecondsDesc:
          'Los primeros 3 segundos de la publicidad son cruciales para el éxito de la publicidad.',
        informationTransmission: 'Momento del mensaje clave',
        informationTransmissionDesc:
          'Medida de la capacidad de la publicidad para captar la atención del público objetivo y estimular el interés.',
        brandRelevance: 'Momento de marca',
        brandRelevanceDesc:
          'Medida de la capacidad del momento de marca para captar la atención del público objetivo y estimular el interés.',
        interestStimulation: 'Momento de interés',
        interestStimulationDesc:
          'Momentos clave que provocan resonancia emocional y pensamiento activo en el público.',
        theEnding3Seconds: 'Los últimos 3 segundos',
        theEnding3SecondsDesc:
          'Basado en la ley del pico y el final, los últimos 3 segundos de la publicidad son cruciales para consolidar la atención del público y reforzar la transmisión de información.',
      },
      infoDrawer: {
        basicInformation: 'Información básica',
        advertisingInformation: 'Información publicitaria',
        projectName: 'Nombre del proyecto',
        brandName: 'Nombre de la marca',
        category: 'Sector',
        norm: 'Norma del mercado objetivo',
        normLabel: 'Norma',
        brandNorm: 'Norma de la marca',
        adName: 'Nombre de la publicidad',
        taGender: 'Género TA',
        targetMarket: 'Mercado objetivo',
        taAge: 'Edad TA',
        ageRange: '{{start}} a {{end}} años',
        modify: 'Modificar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      videoView: {
        eyeMovementRatio: 'Índice de atención',
        cognitiveEngagement: 'Índice cognitivo',
        emotionRecognition: 'Índice emocional',
        subjectiveResponseCurve: 'Curva de respuesta subjetiva',
        realtimeData: 'Datos en tiempo real',
        panoramicData: 'Datos panorámicos',
        indexAnalysis: 'Análisis de índices',
        advantage: 'Ventaja',
        disadvantage: 'Desventaja',
        suggestions: 'Sugerencias',
        adVideoScore: 'Índice de efectividad publicitaria',
        norm: 'Norma',
        analysisStepTitle1: 'Decodificación de contenido',
        analysisStepTitle2: 'Predicción de feedback',
        analysisStepTitle3: 'Integración de datos',
        analysisStepTitle4: 'Inferencia de conclusiones',
        analysisStepDesc1:
          'Inicia la decodificación multimodal de los contenidos publicitarios, decodificación visual, acústica, textual y estructural...',
        analysisStepDesc2:
          'Inicia la predicción de la respuesta subjetiva del público basada en los contenidos de la publicidad...',
        analysisStepDesc3:
          'Inicia la integración de los contenidos objetivos de la publicidad y los datos de respuesta subjetiva del público...',
        analysisStepDesc4:
          'Inicia la generación de recomendaciones de evaluación y acción basadas en el modelo de inferencia...',
        keyResult: 'Resultado clave',
        videoChart: {
          videoFailed: 'Reproducción de video fallida',
          videoFailedAction:
            'Por favor, actualiza y vuelve a intentarlo. Si el problema persiste después de varias actualizaciones, por favor contáctanos para obtener ayuda.',
        },
      },
      storyboardView: {
        summary: 'Resumen',
        advantages: 'Ventajas',
        disadvantages: 'Desventajas',
        suggestions: 'Sugerencias',
        keyResult: 'Resultado clave',
        norm: 'Norma',
        theGolden3Seconds: 'Los tres segundos dorados',
        informationTransmission: 'Momento del mensaje clave',
        brandRelevance: 'Momento de marca',
        interestStimulation: 'Momento de interés',
        theEnding3Seconds: 'Los últimos 3 segundos',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'Correo electrónico',
      username: 'Nombre de usuario',
      password: 'Contraseña',
      setPasswordToEnableEmailLogin:
        'Establecer contraseña para habilitar el inicio de sesión por correo electrónico',
      uid: 'UID',
      contactAndReceiveNotifications: 'Contáctanos y recibe notificaciones',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'Recibe correos electrónicos sobre las últimas actualizaciones de AdEff a esta dirección de correo electrónico.',
      myWorkspace: 'Mi espacio de trabajo',
      newRequest: 'Nueva solicitud',
      invitationCode: 'Código de referencia',
      userName: 'Nombre de usuario',
      invitationCodeDesc:
        'Cada equipo tiene un código de invitación único, que ayuda a los nuevos usuarios a solicitar unirse al equipo durante el registro',
      table: {
        userName: 'Nombre de usuario',
        email: 'Correo electrónico',
        operation: 'Operación',
        admin: 'Administrador',
        remove: 'Eliminar',
        deny: 'Rechazar',
        approve: 'Aprobar',
      },
      message: {
        yourTeamIsFull:
          'Tu equipo está completo. Puedes contactarnos para obtener más miembros o eliminar a otros miembros.',
        invitationLinkSent:
          '¡El enlace de invitación ha sido enviado a esta dirección de correo electrónico!',
        removeReminder: 'Aviso de eliminación',
        remove: 'Eliminar',
        removeMember:
          'Después de eliminar al miembro, los contenidos creados por este miembro permanecerán. ¿Realmente deseas eliminar al miembro?',
        removeMemberSuccess: '¡Miembro eliminado con éxito!',
        ok: 'OK',
        contactUs: 'Contáctanos',
        applicationProcessedSuccessfully: '¡Solicitud procesada con éxito!',
        notificationSettingsTurnedOn: 'Configuraciones de notificación activadas',
        notificationSettingsTurnedOff: 'Configuraciones de notificación desactivadas',
        setPassword: 'Establecer contraseña',
        passwordConfirm: 'Confirmar',
        passwordCancel: 'Cancelar',
        oldPassword: 'Contraseña anterior',
        newPassword: 'Nueva contraseña',
        pleaseEnterTheOldPassword: 'Por favor, ingresa la contraseña anterior',
        pleaseEnterTheNewPassword: 'Por favor, ingresa la nueva contraseña',
        incorrectEntryOfOriginalPassword: 'Entrada incorrecta de la contraseña original',
        passwordUpdatedSuccessfully: 'Contraseña actualizada con éxito',
        changeUsername: 'Cambiar nombre de usuario',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        username: 'Nombre de usuario',
        pleaseEnterTheNewUsername: 'Por favor, ingresa el nuevo nombre de usuario',
        userNameUpdatedSuccessfully: 'Nombre de usuario actualizado con éxito',
        addMemberToWorkspace: 'Agregar nuevo miembro al espacio de trabajo',
        notAdminOperate: 'No es administrador, no puede operar',
        emailAddress: 'Dirección de correo electrónico',
        send: 'Enviar',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'Enviaremos un correo electrónico de invitación a esta dirección para confirmación.',
        workspaceMemberShip: 'Membresía del espacio de trabajo',
        forMoreMembership: 'Para más membresías',
        reachedTheCeiling: 'Has alcanzado el límite máximo.',
        incorrectMailboxFormat: 'Formato de correo electrónico no válido',
        member: 'Miembro',
        changeCorpNameTitle: 'Cambiar nombre de la empresa',
        changeCorpNameLabel: 'Nombre de la empresa',
        pleaseEnterTheCorpName: 'Por favor, ingrese el nombre de la empresa',
        changeCorpNameSuccess: 'Nombre de la empresa cambiado con éxito',
        changeCorpNameFailed: 'Cambio de nombre de la empresa fallido',
        noPermission: 'No tienes permiso para cambiar el nombre de la empresa',
      },
    },
    subscriptionPage: {
      currentPlan: 'Plan actual',
      getInvoice: 'Obtén tu factura',
      remainingTimes: 'Tiempos restantes',
      purchaseMore: 'Comprar más',
      contactUs: 'Contáctanos',
      teamPlan: 'Servicio del equipo de expertos',
      unlimited: 'Ilimitado',
      dueDate: 'Fecha de vencimiento',
      table: {
        usageRecords: 'Registros de uso',
        date: 'Fecha',
        projectName: 'Nombre del proyecto',
        projectType: 'Tipo de proyecto',
        usageCount: 'veces',
        userName: 'Nombre de usuario',
        noRelevantContent: 'No se encontraron contenidos relevantes',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: 'Proyecto de creatividad regular',
      regularCreative: 'Creatividad regular',
      splashCreativeProject: 'Proyecto de creatividad splash',
      splashCreative: 'Creatividad splash',
      projects: 'Proyectos',
      localNorm: 'Valor de referencia local',
      projectPassRate: 'Tasa de aprobación del proyecto',
      passRate: 'Tasa de aprobación',
    },
    dataDetailPage: {
      baseData: 'Datos básicos',
      totalProjects: 'Total de proyectos',
      totalProjectsDesc:
        'Número total de proyectos efectivos que participan en la evaluación de efectividad publicitaria.',
      // averageEffectivenessIndex: 'Índice de efectividad promedio',
      // averageEffectivenessIndexDesc:
      // 'El valor promedio del índice de efectividad publicitaria de todos los proyectos efectivos.',
      localNormProjects: 'Proyectos de referencia local',
      brandNormProjects: 'Proyectos de referencia de la marca',
      normProject: 'Proyecto de referencia del mercado objetivo',
      brandNormProject: 'Proyecto de referencia de la marca',
      localNorm: 'Valor de referencia local',
      localNormDesc:
        'El valor promedio del índice de efectividad publicitaria de los proyectos válidos que tienen como mercado objetivo su país.',
      norm: 'Valor de referencia',
      brandNorm: 'Valor de referencia de la marca',
      brandNormDesc:
        'El valor promedio del índice de efectividad publicitaria de los proyectos válidos que tienen como mercado objetivo el valor de referencia de la marca.',
      localProjectPassRate: 'Tasa de aprobación del proyecto local',
      projectPassRate: 'Tasa de aprobación de proyectos',
      brandProjectPassRate: 'Tasa de aprobación de proyectos de la marca',
      projectPassRateDesc:
        'Proporción de proyectos cuyo índice de efectividad publicitaria supera el valor de referencia en relación con el total de proyectos evaluados.',
      advertisingEffectivenessIndexDistribution:
        'Distribución del índice de efectividad publicitaria',
      advertisingEffectivenessIndexDistributionDesc:
        'Proporción de proyectos en diferentes rangos del índice de efectividad publicitaria.',
      item: 'elementos',
    },
    dataComparisonPage: {
      createCompare: 'Nueva comparación', createCompareDesc: 'Selecciona varios proyectos para comparar, hasta 10 proyectos.', startCompare: 'Iniciar comparación', compareReport: 'Informes de comparación', searchPlaceholder: 'Buscar nombre del informe de comparación', emptyText: 'Aún no hay informes de comparación. Selecciona proyectos para comparar primero.', searchEmptyText: 'No se encontraron informes de comparación.', deleteTitle: 'Eliminar informe de comparación', deleteConfirm: '¿Seguro que quieres eliminar este informe de comparación? Esta acción no se puede deshacer.', projectCount: '{{count}} proyectos',
    },
    dataComparisonStartPage: {
      back: 'Volver', basicInfo: 'Información básica', reportName: 'Nombre del informe:', reportNamePlaceholder: 'Introduce el nombre del informe de comparación', norm: 'Referencia:', normPlaceholder: 'Selecciona la referencia', normTip: 'Selecciona la referencia utilizada para comparar proyectos', selectProject: 'Seleccionar proyectos', searchPlaceholder: 'Buscar por proyecto/anuncio/marca', selectedCountPrefix: ' Seleccionados ', selectedCountSuffix: ' proyectos, hasta {{max}} proyectos', startCompare: 'Iniciar comparación', save: 'Guardar', cancel: 'Cancelar', maxSelectedWarning: 'Puedes seleccionar hasta 10 proyectos', reportNameRequired: 'Introduce el nombre del informe de comparación', normRequired: 'Selecciona la referencia', projectRequired: 'Selecciona proyectos',
    },
    dataComparisonInfoPage: {
      defaultReportName: 'Nombre del informe de comparación', reportNotFound: 'Informe no encontrado', back: 'Volver', modify: 'Editar', deletedProjectTip: 'Los siguientes proyectos: {{names}} se eliminaron. Después de confirmar, se actualizará el informe de comparación y se quitarán los proyectos eliminados.', confirmDeletedProjects: 'Confirmar', metricScore: 'Puntuación del indicador', tabDimension: 'Cinco dimensiones', tabMoment: 'Momento clave', tabAttitude: 'Actitud del consumidor', adeffScore: 'Puntuación AdEff', brandName: 'Nombre de la marca', projectName: 'Nombre del proyecto', industry: 'Sector', targetMarket: 'Mercado objetivo', gender: 'Género del TA', age: 'Edad del TA', adProject: 'Proyecto publicitario', normLabel: 'Referencia', mixedCreativeBenchmarkTip: 'No hay referencia disponible al comparar creatividades generales y creatividades splash simultáneamente.', emptyProject: 'Selecciona proyectos para ver los datos de comparación', viewProjectDetail: 'Ver detalles del proyecto', listSeparator: ', ',
      metricLabels: {
        attention: 'Fuerza de atención',
        infectivity: 'Fuerza emocional',
        delivery: 'Fuerza del mensaje',
        brand: 'Fuerza de marca',
        persuasion: 'Fuerza persuasiva',
        gazeRecognition: 'Reconocimiento de mirada',
        emotionRecognition: 'Reconocimiento de emociones',
        engagementRecognition: 'Reconocimiento de implicación',
        goldenSeconds: 'Los tres segundos dorados',
        brandMoment: 'Momento de marca',
        productMoment: 'Momento de interés',
        messageMoment: 'Momento del mensaje clave',
        endingSeconds: 'Los últimos 3 segundos',
        likeability: 'Agrado',
        newInformation: 'Información nueva',
        messageRelevance: 'Relevancia del mensaje',
        comprehension: 'Comprensión',
        credibility: 'Credibilidad',
        brandLinkage: 'Vinculación con la marca',
        uniqueness: 'Singularidad',
        learnMoreIntent: 'Disposición a saber más',
        purchaseIntent: 'Intención de compra',
        recommendIntent: 'Compartibilidad',
        brandLikeabilityLift: 'Aumento de afinidad de marca',
        purchaseIntentionLift: 'Aumento de intención de compra',
        attentionIndex: 'Índice de atención',
        emotionIndex: 'Índice emocional',
        cognitionIndex: 'Índice cognitivo',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: 'Tu proyecto de evaluación creativa TVC está completo.',
        title: {
          text1: 'Prueba de creatividad publicitaria',
          text2: 'Informe de prueba',
        },
        flowAnalysis: {
          desc1: 'AdEff está descomponiendo tu anuncio en video',
          desc2: 'Descomposición del video completada',
          desc3: 'Analizando la atención visual del consumidor',
          desc4: 'Analizando el foco visual según los perfiles de consumidores',
          desc5: 'Generando mapa de calor de atención',
          desc6: 'Mapa de calor dinámico generado',
          desc7: 'Midiendo respuestas cognitivo-neuronales',
          desc8: 'Rastreando mirada, emoción e implicación segundo a segundo',
          desc9: 'Generando curva de respuesta neuronal',
          desc10: 'Curva de respuesta neuronal generada',
          desc11: 'Analizando el rendimiento en momentos clave',
          desc12: 'Midiendo respuestas cognitivo-neuronales durante: 3 segundos de oro, momento del mensaje, momento de marca, pico de interés y últimos 3 segundos',
          desc13: 'Sintetizando métricas de momentos clave',
          desc14: 'Análisis de momentos clave completado',
          desc15: 'Analizando actitudes del consumidor',
          desc16: 'Analizando actitudes hacia la marca, el producto y el contenido',
          desc17: 'Sintetizando métricas de actitud',
          desc18: 'Métricas de actitud completadas',
          desc19: 'Generando puntuaciones de las cinco fuerzas',
          desc20: 'Puntuaciones de las cinco fuerzas listas',
          desc21: '¡Análisis completado! Tu informe de rendimiento del anuncio está listo',
          terminology: {
            thumbExpand: 'Expandir miniaturas',
            thumbCollapse: 'Contraer miniaturas',
            gazeRecognition: 'Reconocimiento de mirada',
            gazeRecognitionDesc: 'Mide la concentración de la atención visual e indica qué tan eficazmente los elementos del anuncio captan el foco del espectador.',
            emotionRecognition: 'Reconocimiento de emociones',
            emotionRecognitionDesc: 'Cuantifica las emociones positivas y las respuestas afectivas inmediatas generadas por el anuncio.',
            engagementRecognition: 'Reconocimiento de implicación',
            engagementRecognitionDesc: 'Mide la inmersión y la implicación, reflejando la inversión mental en el contenido del anuncio.',
            theGolden3Seconds: 'Rendimiento de los 3 segundos de oro',
            theGolden3SecondsDesc: 'Evalúa la eficacia del contenido del anuncio durante los primeros 3 segundos.',
            keyMessage: 'Rendimiento del mensaje clave',
            keyMessageDesc: 'Mide la capacidad de los momentos informativos del anuncio para captar atención y estimular interés.',
            brand: 'Rendimiento de marca',
            brandDesc: 'Evalúa la captación de atención específica de la marca y la eficacia de la implicación.',
            interest: 'Pico de interés',
            interestDesc: 'Identifica picos de contenido que generan resonancia emocional y alta implicación.',
            ending3Seconds: 'Rendimiento de los últimos 3 segundos',
            ending3SecondsDesc: 'Evalúa la eficacia del contenido del anuncio en los últimos 3 segundos.',
            score: 'Puntuación',
            benchmark: 'Referencia',
            metrics: 'Métricas',
            attitudePart: {
              attitudeMetrics: 'Métricas de actitud',
              liking: 'Agrado',
              likingDesc: 'Mide la actitud subjetiva de la audiencia y su grado general de agrado hacia el anuncio.',
              newInformation: 'Información nueva',
              newInformationDesc: 'Mide si la audiencia cree haber obtenido del anuncio información valiosa y previamente desconocida sobre la marca o el producto.',
              messageRelevance: 'Relevancia del mensaje',
              messageRelevanceDesc: 'Mide en qué medida la audiencia percibe que la información del anuncio está directamente relacionada con ella.',
              comprehension: 'Comprensión',
              comprehensionDesc: 'Mide si el mensaje clave del anuncio se entendió de forma clara, precisa y sin esfuerzo.',
              credibility: 'Credibilidad',
              credibilityDesc: 'Mide hasta qué punto la audiencia cree que la información transmitida es verdadera, fiable y digna de confianza.',
              brandLinkage: 'Vinculación con la marca',
              brandLinkageDesc: 'Mide la capacidad de la audiencia para asociar correcta y firmemente el anuncio con la marca específica.',
              uniqueness: 'Singularidad',
              uniquenessDesc: 'Mide si el anuncio establece una percepción clara de que la marca tiene una singularidad distintiva y valiosa frente a sus competidores.',
              willing: 'Disposición a saber más',
              willingDesc: 'Mide la probabilidad subjetiva de que la audiencia tome medidas activas para conocer mejor la marca o el producto después de ver el anuncio.',
              purchase: 'Intención de compra',
              purchaseDesc: 'Mide la probabilidad subjetiva de que la audiencia considere elegir o comprar el producto de la marca en el futuro.',
              share: 'Compartibilidad',
              shareDesc: 'Mide la probabilidad subjetiva de que la audiencia comparta activamente el anuncio o la información de la marca con otras personas.',
              brandLikeLift: 'Aumento de afinidad de marca',
              brandLikeLiftDesc: 'Mide la dirección y el grado de cambio en el agrado general hacia la marca o el producto tras la exposición al anuncio.',
              purchaseIntentLift: 'Aumento de intención de compra',
              purchaseIntentLiftDesc: 'Mide la dirección y el grado de cambio en la disposición a considerar la compra del producto de la marca tras la exposición al anuncio.',
            },
            dimensionPart: {
              forceDrives: 'Fuerzas impulsoras',
              attension: 'Atención',
              emotionalImpact: 'Impacto emocional',
              messageClarity: 'Claridad del mensaje',
              brandPower: 'Fuerza de marca',
              persuasion: 'Persuasión',
              attentionForce: 'Fuerza de atención',
              attentionForceDesc: 'Mide la capacidad del anuncio para captar y mantener la atención visual y auditiva de la audiencia.',
              emotionalForce: 'Fuerza emocional',
              emotionalForceDesc: 'Mide la intensidad de la resonancia emocional inmediata e instintiva provocada por el contenido del anuncio.',
              messageForce: 'Fuerza del mensaje',
              messageForceDesc: 'Mide la eficacia con la que el mensaje central del anuncio es identificado, comprendido y recordado por la audiencia objetivo.',
              brandForce: 'Fuerza de marca',
              brandForceDesc: 'Mide la eficacia del anuncio para reforzar la identidad de marca, mejorar la favorabilidad y construir una conexión sólida con la marca.',
              persuasiveForce: 'Fuerza persuasiva',
              persuasiveForceDesc: 'Mide el poder final del anuncio para cambiar percepciones e impulsar intenciones de comportamiento.',
            },
            result: {
              results: 'Resultados',
              pass: 'Aprobado',
              notPass: 'No aprobado',
              adeffScore: 'Puntuación AdEff',
              adeffScoreDesc: 'La puntuación AdEff está diseñada para medir la eficacia general de los anuncios.',
              benchmarkDesc: 'La puntuación AdEff media de todos los anuncios subidos en el país o región del anuncio se usa para comparar su rendimiento.',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: 'Esperando...',
            description: 'Generando el informe de prueba...',
          },
          generating: 'Generando...',
          freeTrialLockText1:
            'En modo de prueba no se puede previsualizar ni descargar el informe completo.',
          freeTrialLockText2: 'Suscríbete para desbloquearlo.',
        },
      },
    },
  },
  professor: {
    account: 'Cuenta',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    expertReviews: 'Reseñas de expertos',
    adVideoScore: 'Índice de efectividad publicitaria',
    subjectiveResponseCurve: 'Curva de respuesta subjetiva',
    indexAnalysis: 'Análisis de índices',
    keyResult: 'Resultado clave',
    theGolden3Seconds: 'Los tres segundos dorados',
    informationTransmission: 'Momento del mensaje clave',
    brandRelevance: 'Momento de marca',
    interestStimulation: 'Momento de interés',
    theEnding3Seconds: 'Los últimos 3 segundos',
    heatMap: 'Mapa de calor',
    suggestion: 'Sugerencias',
    suggestion1: 'Sugerencia',
    submit: 'Enviar',
    next: 'Siguiente',
    summary: 'Resumen',
    advantages: 'Ventajas',
    disadvantages: 'Desventajas',
    option1: 'Esperado',
    option2: 'No esperado',
    resultJudgment: 'Evaluación',
    placeholder: 'Por favor, ingrese una sugerencia',
    waitRateCount: 'Número de anuncios a evaluar',
    unfinishedTitle: 'Aviso',
    unfinishedRate: 'El proyecto tiene elementos incompletos, ¿desea confirmar la salida?',
    unfinishedConfirm: 'Continuar evaluación',
    unfinishedCancel: 'Salir',
    message: {
      submitSuccess: 'Gracias por su evaluación',
      submitSuccess1: 'Ha completado la evaluación de este proyecto, gracias por su evaluación',
      loginSuccess: 'Inicio de sesión exitoso',
      rateUnfinished:
        'Aún no ha evaluado el contenido actual, por favor complételo antes de pasar a la siguiente pregunta',
      rateLocation: 'Hemos seleccionado automáticamente los elementos incompletos para ti',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'Solicitar una prueba',
      title1: 'Prueba gratuita',
      trial: 'Prueba',
      hiddenBoxText1: 'Se han detectado varias ventajas, desventajas y sugerencias',
      hiddenBoxText2: 'Suscribirse para obtener el informe completo',
      hiddenBoxBtn: 'Suscribirse ahora',
      applyBox: {
        name: 'Su nombre',
        tel: 'Número de contacto',
        department: 'Departamento',
        role: 'Rol',
        country: 'País',
        city: 'Ciudad',
        pleaseEnter: 'Por favor, ingrese',
        pleaseSelect: 'Por favor, seleccione',
        pleaseEnterTheName: 'Por favor, ingrese su nombre',
        pleaseEnterTheTel: 'Por favor, ingrese su número de contacto',
        pleaseEnterValidTel: 'Por favor, ingrese un número de contacto válido',
        pleaseEnterValidEmail: 'Por favor, ingrese un correo electrónico válido',
        pleaseSelectTheDepartment: 'Por favor, seleccione su departamento',
        pleaseSelectTheRole: 'Por favor, seleccione su rol',
        pleaseSelectTheCountry: 'Por favor, seleccione su país',
        pleaseEnterTheCity: 'Por favor, ingrese su ciudad',
        textIsRequired: 'Este campo es obligatorio',
        submit: 'Enviar',
        tip: 'Cada empresa tiene solo una oportunidad de prueba gratuita',
      },
      gotTrial: '¡Has recibido una prueba!',
      goPc: 'Por favor, ve a la versión web de PC para crear tu proyecto.',
      back: 'Volver',
      country: {
        China: 'China',
        Japan: 'Japón',
        Korea: 'Corea',
        Indonesia: 'Indonesia',
        Thailand: 'Tailandia',
        Singapore: 'Singapur',
        Malaysia: 'Malasia',
        Vietnam: 'Vietnam',
        Germany: 'Alemania',
        Britain: 'Reino Unido',
        France: 'Francia',
        Italy: 'Italia',
        Russia: 'Rusia',
        Spain: 'España',
        Turkey: 'Turquía',
        America: 'Estados Unidos',
        Canada: 'Canadá',
        Brazil: 'Brasil',
        Other: 'Otro',
      },
      department: {
        Brand: 'Marca',
        Market: 'Mercado',
        Marketing: 'Marketing',
        IT: 'IT',
        Procurement: 'Compra',
        Other: 'Otro',
      },
      role: {
        President: 'Presidente/Vicepresidente/Gerente General',
        CMO: 'CMO o Otro Gerente de Nivel C',
        Director: 'Director de Departamento',
        Manager: 'Gerente de Departamento',
        Other: 'Otro',
      },
      message: {
        submitSuccess: 'Envío exitoso',
        submitFailed: 'Envío fallido, por favor intente nuevamente más tarde',
      },
    },
    downloadPptRechargeModal: {
      title: 'No se puede descargar el informe',
      desc1: 'En la versión de prueba no se puede descargar el informe',
      desc2: 'Suscribirse para obtener el informe completo',
      btn: 'Suscribirse ahora',
    },
    checkInvitationCodeModal: {
      invitationCode: 'Código de referencia',
      invitationCodeDesc1:
        'El código de referencia no se puede modificar, por favor contáctanos si necesitas modificarlo',
      invitationCodeDesc2:
        'Si estás usando esto a través de una referencia de agente, por favor ingresa el código de referencia',
      invitationCodePlaceholder: 'Por favor ingresa el código de referencia',
      invitationCodeError: 'Código de referencia inválido',
      invitationCodeSuccess: 'Código de referencia actualizado con éxito',
      ok: 'OK',
      cancel: 'Cancelar',
    },
    aigcPromotionModal: {
      title: 'Beneficios para creadores AIGC',
      subTitle:
        'Regístrate ahora para obtener <tmp>5</tmp> oportunidades de evaluación de video con IA',
      desc1: 'Únete al evento de pruebas creativas con IA de AdEff para evaluar tus creatividades.',
      desc2: 'Regístrate ahora y reclama al instante 5 pruebas gratuitas.',
      registerBtn: 'Regístrate para obtener oportunidades de prueba',
      tip: 'Solo para nuevos usuarios registrados a través de la entrada de la campaña para creadores AIGC',
      floatTitle: 'Prueba gratuita',
    },
  },
}

export default TRANSLATION
